<template>
    <div>
        <static-loading-indicator-icon :with-card="true"></static-loading-indicator-icon>

        <transition name="component-fade" mode="out-in">
            <div v-if="!$store.getters.isExecutingRequest">
                <page-header :title="'Serie: ' + series.title[$i18n.locale]" icon-class="mdi mdi-television">

                    <div class="text-right" v-if="$store.getters.isAdmin">
                        <router-link tag="a" :to="{name: 'admin.series.edit'}" class="text-warning font-weight-bold">
                            <i class="mdi mdi-pencil"></i> {{ $t('actions.edit') }}
                        </router-link>
                    </div>

                </page-header>

                <img :src="series.thumbnail_url" :alt="series.title[$i18n.locale]" class="img-fluid mb-4 rounded"
                     v-if="hasThumbnail">

                <div class="card mb-3" v-if="series.description !== null">
                    <div class="card-body shadow-sm" style="border: 1px solid black;">
                        {{ series.description[$i18n.locale] }}
                    </div>
                </div>

                <div v-if="series.videos && series.videos.length">
                    <div class="row">
                        <div class="col-md-4 grid-margin" v-for="video in series.videos" :key="video.id">
                            <gym-video-card-new :video="video" :page-link-enabled="true"/>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="alert alert-secondary border-dark">
                        {{ $t('pages.series.not_containing_videos') }}
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import VideoSeriesRepository from "../../repositories/Gym/VideoSeriesRepository";
import PageHeader from "../Includes/PageHeader";
import GymVideoCardNew from "../Gym/Includes/GymVideoCardNew";
import StaticLoadingIndicatorIcon from "../Includes/StaticLoadingIndicatorIcon";

export default {
    name: "ShowSeries",
    components: {StaticLoadingIndicatorIcon, GymVideoCardNew, PageHeader},
    data: () => ({
        series: null
    }),
    watch: {
        slug: function (val) {
            this.getSeries();
        }
    },
    computed: {
        hasThumbnail() {
            if (this.series.thumbnail_url === null)
                return false;

            return !this.series.thumbnail_url.includes("placehold.it");
        },
        slug() {
            return this.$route.params.slug;
        },
        videos() {
            return this.series.videos;
        }
    },
    methods: {
        getSeries() {
            VideoSeriesRepository
                .getSeries(this.slug)
                .then((res) => this.series = res.data);
        }
    },
    mounted() {
        this.getSeries();
    }
}
</script>

<style scoped>

</style>
